
import "@sparta.global.modules/get-app-modal-module/dist/styles.css"
import "@sparta.auto-loans.modules/get-prequalified-module/dist/styles.css"
import "@sparta.auto-loans.modules/engagement-unauth-auto-module/dist/styles.css"
import "@sparta.auto-loans.modules/rates-table-module/dist/styles.css"
import "@sparta.auto-loans.modules/two-column-with-image-module/dist/styles.css"
import "@sparta.auto-loans.modules/preferred-rewards-module/dist/styles.css"
import "@sparta.auto-loans.modules/disclosure-module/dist/styles.css"
import "@sparta.auto-loans.modules/auto-loans-calculator-module/dist/styles.css"
import "@sparta.auto-loans.modules/jumbotron-2col-auto-module/dist/styles.css"
import "@sparta.auto-loans.modules/learning-center-module/dist/styles.css"


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import ampTriggerVideoUtility from "@sparta.global.utilities/amp-trigger-video-utility/dist/es6.js"
import secureLinkUtility from "@sparta.global.utilities/secure-link-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import spartaRegisterSwUtility from "@sparta.global.utilities/sparta-register-sw-utility/dist/es6.js"
import cspStyleBinder from "@sparta.sales.utilities/csp-style-binder/dist/es6.js"

import "@sparta.global.modules/get-app-modal-module/dist/es6.js"
import "@sparta.sales.modules/states-event-module/dist/es6.js"
import "@sparta.auto-loans.modules/engagement-unauth-auto-module/dist/es6.js"
import "@sparta.auto-loans.modules/get-prequalified-module/dist/es6.js"
import "@sparta.auto-loans.modules/rates-table-module/dist/es6.js"
import "@sparta.auto-loans.modules/two-column-with-image-module/dist/es6.js"
import "@sparta.auto-loans.modules/two-column-with-image-module/dist/es6.js"
import "@sparta.auto-loans.modules/auto-loans-calculator-module/dist/es6.js"
import "@sparta.auto-loans.modules/preferred-rewards-module/dist/es6.js"
import "@sparta.auto-loans.modules/jumbotron-2col-auto-module/dist/es6.js"
import "@sparta.auto-loans.modules/learning-center-module/dist/es6.js"
import "@sparta.auto-loans.modules/disclosure-module/dist/es6.js"


window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [

  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  secureLinkUtility.run()
await spartaBootstrapUtility.init(arguments);
spartaRegisterSwUtility.init();
cspStyleBinder.bindStyle();
  console.log('after - execute boot functions')
})();
